module.exports = __webpack_public_path__ + "static/media/Cube_10x10x10.4a4a0900.png";